// extracted by mini-css-extract-plugin
export default {"side-menu":"SideMenu_side-menu__0d8no","collapsed":"SideMenu_collapsed__2Pe91"};